import { EnvironmentTypes } from 'helper/types';
import { useEffect } from 'react';
import { useLazyGetSystemVersionQuery } from 'services/system';

export const useGetSystemVersion = () => {
    const environment = import.meta.env.VITE_ENV_CONFIG;

    const isAllowedEnvironment =
        environment === EnvironmentTypes.PRODUCTION ||
        environment === EnvironmentTypes.PREPROD ||
        environment === EnvironmentTypes.LOCAL;

    const [getSystemVersion, { data, isFetching }] = useLazyGetSystemVersionQuery();

    useEffect(() => {
        /*
		  The previous implementation was supposed to present
		  the system version only in PRODUCTION environment.
		  Validate if the same rule should be applied to PREPROD.
	  */
        if (isAllowedEnvironment) {
            getSystemVersion('getSystemVersion');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        environment,
        systemVersion: data?.version,
        isFethingSystemVersion: isFetching,
    };
};
